import { Device, from, until } from '@helpers/media';
import styled, { css } from 'styled-components';
import MotionTrack from '../Misc/Carousels/Carousel/MotionTrack/MotionTrack';
import MotionTrackStyles from '../Misc/Carousels/Carousel/MotionTrack/MotionTrack.styles';
import PaginationStyles from '../Misc/Carousels/Carousel/Pagination/Pagination.styles';
export const cardWidth = css `
  flex: var(--grow) 0
    calc(
      100% / var(--rowItems) - (var(--gap) * ((var(--rowItems) - 1) / var(--rowItems))) -
        (var(--itemPeek, 0px) / var(--rowItems))
    );

  @media ${from(Device.TabletLarge)} {
    max-width: var(--maxWidth);
  }
`;
const Track = styled(MotionTrack) `
  margin: 0 calc(var(--gap) * -0.5);
  width: calc(100% + var(--gap));

  // Unset container when carousel is disabled
  @media ${from(Device.TabletLarge)} {
    display: contents;

    ${MotionTrackStyles.Track} {
      display: contents;
    }
  }
`;
const Item = styled.li `
  display: flex;
  padding: 0 calc(var(--gap) * 0.5);
  flex: 0 0 calc(100% / var(--rowItems) - (var(--itemPeek, 0px) / var(--rowItems)));

  // Remove flex styling from the card whilst the mobile carousel is enabled
  @media ${until(Device.TabletLarge)} {
    > div,
    > a,
    > article {
      flex: 0 0 100% !important;
    }
  }

  // Unset container when carousel is disabled
  @media ${from(Device.TabletLarge)} {
    display: contents;
  }
`;
const Container = styled.section `
  --alignment: center; // Flexbox alignment (eg. flex-start, center, flex-end)
  --grow: 1; // Flex grow - 0 for equal width, 1 for auto width
  --rowItems: 1; // Number of items per row
  --maxWidth: 50%; // Max width a card can be
  --gap: var(--gutterWidth); // Defaults to global grid gap

  --controlsMargin: 24px; // Margin above the carousel controls
  --itemPeek: 0px; // Carousel peek, use if carousel is enabled

  display: flex;
  flex-wrap: wrap;
  justify-content: var(--alignment);
  gap: var(--gap);
  flex-flow: row wrap;

  ${PaginationStyles.Container} {
    margin: calc(var(--controlsMargin) - var(--gap)) 0 0;
    flex: 0 0 100%;
  }

  /**
    * Force --grow to be 0 if there are more than the configured cards per frow, to keep next row cards equal size.
    */
  &[data-row-max='1']:has(> :nth-child(1)) {
    --grow: 0 !important;
  }

  &[data-row-max='2']:has(> :nth-child(2)) {
    --grow: 0 !important;
  }

  &[data-row-max='3']:has(> :nth-child(3)) {
    --grow: 0 !important;
  }

  &[data-row-max='4']:has(> :nth-child(4)) {
    --grow: 0 !important;
  }

  &[data-row-max='5']:has(> :nth-child(5)) {
    --grow: 0 !important;
  }

  &[data-row-max='6']:has(> :nth-child(6)) {
    --grow: 0 !important;
  }

  // Remove peek and hide carousel controls
  @media ${from(Device.TabletLarge)} {
    --itemPeek: 0px !important;

    ${PaginationStyles.Container} {
      display: none;
    }

    &:has(${Track}) {
      // Repeat the removal of grow for grids with a mobile carousel
      &[data-row-max='1'] {
        ${MotionTrackStyles.Track}:has(> :nth-child(1)) {
          --grow: 0 !important;
        }
      }

      &[data-row-max='2'] {
        ${MotionTrackStyles.Track}:has(> :nth-child(2)) {
          --grow: 0 !important;
        }
      }

      &[data-row-max='3'] {
        ${MotionTrackStyles.Track}:has(> :nth-child(3)) {
          --grow: 0 !important;
        }
      }

      &[data-row-max='4'] {
        ${MotionTrackStyles.Track}:has(> :nth-child(4)) {
          --grow: 0 !important;
        }
      }

      &[data-row-max='5'] {
        ${MotionTrackStyles.Track}:has(> :nth-child(5)) {
          --grow: 0 !important;
        }
      }

      &[data-row-max='6'] {
        ${MotionTrackStyles.Track}:has(> :nth-child(6)) {
          --grow: 0 !important;
        }
      }
    }
  }
`;
const CardGridStyles = {
    Container,
    Track,
    Item,
};
export default CardGridStyles;
